import React from 'react'

interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {}

export const Form: React.FC<FormProps> = (props) => {
  const { children, ...formProps } = props
  return <form {...formProps}>{children}</form>
}
